import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import * as ProjectActions from "../../data/projects/ProjectActions";

import ProjectCard from './ProjectCard';

const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = {
    removeProject: ProjectActions.removeProject,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectCard);
